module.exports = __webpack_public_path__ + "img/listadsfooter.1a1da74f.png";